import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
// import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "../src/styles/theme";
import "@fontsource/montserrat/400.css"
import BlankApp from "./BlankApp";

ReactDOM.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      {/* <App /> */}
      <BlankApp />
    </ChakraProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
